import { Dropdown, EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { EPersonalInfoFields, TPersonalInfoValues } from '../ProfileEdit';
import { currenciesArray } from './currencies';

interface ISettingsProps {
  control: Control<TPersonalInfoValues>;
  errors: FieldErrors<TPersonalInfoValues>;
}

export const Settings = ({ control, errors }: ISettingsProps) => {
  const intl = useIntl();

  const timeZones = Intl.supportedValuesOf('timeZone');

  const currencies = currenciesArray(intl);

  return (
    <>
      <Heading variant={EHeadingStyleVariant.H6} className="mb-6">
        <FormattedMessage defaultMessage="Settings" id="D3idYv" />
      </Heading>
      {timeZones.length !== 0 && (
        <div className="mt-3">
          <Controller
            name={EPersonalInfoFields.LocaleTimezone}
            control={control}
            rules={{
              required: intl.formatMessage({
                defaultMessage: 'Time zone is a required field.',
                id: 'EEdZoD',
              }),
            }}
            render={({ field: { value, onChange } }) => {
              return (
                <Dropdown
                  label={intl.formatMessage({
                    defaultMessage: 'Time zone',
                    id: 'IcUakl',
                  })}
                  ariaLabel={intl.formatMessage({
                    defaultMessage: 'Add a time zone',
                    id: 'aaeJBy',
                  })}
                  inputValue={value || ''}
                  onChange={onChange}
                  searchEnabled={true}
                  error={!!errors.localeTimezone}
                  helperText={errors.localeTimezone?.message}>
                  {timeZones.map(a => (
                    <Dropdown.Option
                      key={a}
                      content={{
                        label: a,
                      }}
                      value={a}
                    />
                  ))}
                </Dropdown>
              );
            }}
          />
        </div>
      )}
      {currencies.length !== 0 && (
        <div className="mt-3">
          <Controller
            name={EPersonalInfoFields.LocaleBaseCurrency}
            control={control}
            rules={{
              required: intl.formatMessage({
                defaultMessage: 'Default currency is a required field.',
                id: 'y5VBNw',
              }),
            }}
            render={({ field: { value, onChange } }) => {
              return (
                <Dropdown
                  label={intl.formatMessage({
                    defaultMessage: 'Default currency',
                    id: 'nGY+Zu',
                  })}
                  ariaLabel={intl.formatMessage({
                    defaultMessage: 'Add a default currency',
                    id: 'xeJwvv',
                  })}
                  inputValue={value || 'USD'}
                  onChange={onChange}
                  error={!!errors.localeBaseCurrency}
                  helperText={errors.localeBaseCurrency?.message}>
                  {currencies.map(a => (
                    <Dropdown.Option
                      key={a.name}
                      content={{
                        label: a.translatedName,
                      }}
                      value={a.currency}
                    />
                  ))}
                </Dropdown>
              );
            }}
          />
        </div>
      )}
    </>
  );
};
